module.exports = __webpack_public_path__ + "static/mike-martin-headshot-a99f745b607b001589677887f4637129.jpg";